import apiClient from './api';

export interface EmailLog {
  email_log_id: string;
  email_type: string;
  subject: string;
  content: string;
  recipients: string[];
  successful_recipients: string[];
  failed_recipients: string[];
  status: string;
  error_message?: string;
  retry_count: number;
  sent_at?: string;
  from_name?: string;
  from_email: string;
  sent_by?: {
    username: string;
    email: string;
  };
  metadata?: any;
  created_at: string;
  updated_at: string;
}

export interface EmailStats {
  total: number;
  sent: number;
  failed: number;
  pending: number;
  cancelled: number;
}

export interface SearchEmailLogsDto {
  query?: string;
  status?: string;
  email_type?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}

export interface ResendEmailDto {
  subject: string;
  content: string;
  recipients: string[];
  from_name?: string;
}

export const emailLogService = {
  // 이메일 로그 목록 조회
  async getEmailLogs(params?: SearchEmailLogsDto): Promise<{
    logs: EmailLog[];
    total: number;
  }> {
    const response = await apiClient.get('/email-logs', { params });
    return response.data;
  },

  // 이메일 로그 통계 조회
  async getEmailStats(): Promise<EmailStats> {
    const response = await apiClient.get('/email-logs/stats');
    return response.data;
  },

  // 이메일 로그 삭제
  async deleteEmailLog(emailLogId: string): Promise<void> {
    await apiClient.delete(`/email-logs/${emailLogId}`);
  },

  // 이메일 재발송
  async resendEmail(emailLogId: string, emailData: ResendEmailDto): Promise<void> {
    await apiClient.post(`/email-logs/${emailLogId}/resend`, emailData);
  },
}; 